import React from 'react'
import Link from 'next/link'
import useUniqueId from '../../hooks/use-unique-id'
import { Label } from './../index'

export type OptionType = {
  value: string
  text: string
  href?: string
}

type Props = {
  onChange: (arg0: string) => void
  value: string
  options: OptionType[]
  label?: string
  hiddenLabel?: boolean
  className?: string
  style?: React.CSSProperties
  link?: boolean
}

export const Select = ({
  onChange,
  value,
  options,
  label = '',
  hiddenLabel = false,
  className = '',
  style = {},
  link,
}: Props) => {
  const selectId = useUniqueId('select')
  const includeLabel = label || hiddenLabel

  return (
    <>
      {includeLabel && (
        <Label htmlFor={selectId} className={hiddenLabel ? 'u-sr-only' : ''}>
          {label}
        </Label>
      )}
      <select
        id={selectId}
        className={className}
        onChange={e => {
          e.preventDefault()
          onChange(e.currentTarget.value)
          e.currentTarget.blur()
        }}
        style={style}
        value={value}>
        {options.map((option, i) => (
          <React.Fragment key={i}>
            {link ? (
              <option value={option.value}>
                <Link prefetch={false} href={option.href as any}>
                  {option.text}
                </Link>
              </option>
            ) : (
              <option value={option.value}>{option.text}</option>
            )}
          </React.Fragment>
        ))}
      </select>
    </>
  )
}

export default Select
